export const translations = {
  TR: {
    app_title: "PartSpare AI",
    tagline: "Yedek Parça Platformu",
    login: "Giriş Yap",
    register: "Kayıt Ol",
    logout: "Çıkış",
    email: "E-posta",
    password: "Şifre",
    name: "Ad Soyad",
    phone_number: "Telefon Numarası",
    company: "Şirket",
    industry_class: "Sektör",
    select_industry: "Sektör seçiniz",
    not_a_robot: "Robot değilim",
    robot_required: "Lütfen 'Robot değilim' kutusunu işaretleyin",
    forgot_password: "Şifremi Unuttum?",
    back_to_login: "Girişe Dön",
    send_reset: "Sıfırlama Bağlantısı Gönder",
    reset_password: "Şifreyi Sıfırla",
    new_password: "Yeni Şifre",
    dont_have_account: "Hesabın yok mu?",
    have_account: "Zaten hesabın var mı?",
    search_placeholder: "Parça No (PN) veya Parça Adı giriniz (ör: Turbine Rotor 448-B)...",
    search_btn: "Ara",
    all: "Tümü",
    drone: "Drone / İHA",
    aircraft: "Uçak Parçaları",
    machinery: "Makine Parçaları",
    ai_searching: "Yapay Zeka Küresel Satıcıları ve Stokları Tarıyor...",
    scan_step1: "Küresel Havacılık Veritabanları sorgulanıyor...",
    scan_step2: "Parça Numarası (PN) eşleştiriliyor...",
    scan_step3: "MilSis stokları filtreleniyor...",
    scan_step4: "Sonuçlar derleniyor...",
    in_our_stock: "MİLSİS STOKLARINDA VAR",
    global_supplier: "Küresel Tedarikçi",
    marketplace: "Pazar Yeri",
    results: "Sonuçlar",
    seller: "Satıcı",
    location: "Konum",
    price: "Fiyat",
    stock: "Stok",
    condition: "Durum",
    lead_time: "Teslimat",
    action: "İşlem",
    add_to_cart: "Sepete Ekle",
    view_source: "Kaynak",
    no_results: "Sonuç bulunamadı. Farklı bir parça deneyin.",
    cart: "Sepetim",
    cart_empty: "Sepetiniz boş.",
    checkout: "Ödemeye Geç",
    total: "Toplam",
    remove: "Kaldır",
    payment_placeholder: "Ödeme Altyapısı Hazırlık Aşamasındadır. Siparişiniz talep olarak kaydedildi.",
    orders: "Siparişlerim",
    order_placed: "Sipariş oluşturuldu",
    membership: "Üyelik",
    basic_membership: "Temel Üyelik",
    pro_membership: "Alıcı / Satıcı",
    searches_left: "Kalan Arama",
    unlimited: "Sınırsız",
    upgrade: "Yükselt ($3000/Yıl)",
    upgrade_success: "Üyeliğiniz Alıcı/Satıcı seviyesine yükseltildi!",
    request_sent: "Üyelik talebiniz alındı. Ödeme için ekibimiz e-posta ile sizinle iletişime geçecek. Ödeme sonrası hesabınız aktifleştirilecek.",
    request_membership: "Talep Gönder ($3000/Yıl)",
    activation_note: "Ödeme tamamlandıktan sonra aktifleştirilir.",
    basic_desc: "10 adet parça arama hakkı",
    pro_desc: "Sınırsız arama + Kendi parçalarınızı sisteme kaydetme",
    sell_parts: "Parça Sat / Ekle",
    my_parts: "Parçalarım",
    add_part: "Parça Ekle",
    pn: "Parça No (PN)",
    part_name: "Parça Adı",
    category: "Kategori",
    quantity: "Adet",
    part_added: "Parça eklendi",
    admin_panel: "Yönetim Paneli",
    dashboard: "Panel",
    stats: "İstatistikler",
    stock_mgmt: "Stok Yönetimi",
    order_mgmt: "Sipariş Yönetimi",
    search_logs: "Arama Kayıtları",
    visits_tab: "Ziyaret Verisi",
    visitors: "Ziyaretçi",
    unique_visitors: "Tekil Ziyaretçi",
    country: "Ülke",
    visits_count: "Ziyaret",
    total_users: "Kullanıcı",
    total_orders: "Sipariş",
    pending: "Bekleyen",
    total_stock: "Stok Kalemi",
    total_searches: "Arama",
    status: "Durum",
    date: "Tarih",
    query: "Arama",
    save: "Kaydet",
    cancel: "İptal",
    delete: "Sil",
    contact_us: "İletişim: info@milsissav.com",
    limit_reached: "Temel arama limitiniz doldu. Sınırsız arama için üyeliğinizi yükseltin.",
    select_category_first: "Lütfen önce bir alan seçin (Drone, Uçak veya Makine).",
    hero_sub: "Drone, Uçak ve Makine yedek parçalarını yapay zeka ile dünya genelinde anında bulun.",
    memberships_tab: "Üyelikler",
    valid_until: "Geçerlilik",
    download_invoice: "Faturayı İndir (PDF)",
    days_short: "gün",
    invoice_archive: "Geçmiş Faturalar",
    member_activate: "Aktif Et",
    member_deactivate: "Pasife Al",
    member_activated: "Üyelik aktifleştirildi ve kullanıcıya e-posta gönderildi",
    member_deactivated: "Üyelik pasife alındı",
    requested_at: "Talep Tarihi",
    plan: "Plan",
    no_requests: "Üyelik talebi bulunmuyor",
    status_pending: "Ödeme Bekliyor",
    status_approved: "Aktif",
    admin_login_title: "Yönetici Girişi",
    admin_login_desc: "Bu alan yalnızca yöneticiler içindir",
    admin_login_error: "Bu alana yalnızca yöneticiler girebilir",
    back_to_site: "← Siteye dön",
  },
  ENG: {
    app_title: "PartSpare AI",
    tagline: "Spare Parts Platform",
    login: "Sign In",
    register: "Register",
    logout: "Logout",
    email: "Email",
    password: "Password",
    name: "Full Name",
    phone_number: "Phone number",
    company: "Company",
    industry_class: "Industry class",
    select_industry: "Select industry class",
    not_a_robot: "I'm not a robot",
    robot_required: "Please confirm you're not a robot",
    forgot_password: "Forgot Password?",
    back_to_login: "Back to Sign In",
    send_reset: "Send Reset Link",
    reset_password: "Reset Password",
    new_password: "New Password",
    dont_have_account: "Don't have an account?",
    have_account: "Already have an account?",
    search_placeholder: "Enter Part Number (PN) or Part Name (e.g. Turbine Rotor 448-B)...",
    search_btn: "Search",
    all: "All",
    drone: "Drone / UAV",
    aircraft: "Aircraft Parts",
    machinery: "Machinery Parts",
    ai_searching: "AI is scanning global suppliers & internal inventory...",
    scan_step1: "Querying global aerospace repositories...",
    scan_step2: "Matching Part Number (PN)...",
    scan_step3: "Filtering MilSis inventory...",
    scan_step4: "Compiling results...",
    in_our_stock: "AVAILABLE IN MILSIS STOCK",
    global_supplier: "Global Supplier",
    marketplace: "Marketplace",
    results: "Results",
    seller: "Seller",
    location: "Location",
    price: "Price",
    stock: "Stock",
    condition: "Condition",
    lead_time: "Lead Time",
    action: "Action",
    add_to_cart: "Add to Cart",
    view_source: "Source",
    no_results: "No results found. Try a different part.",
    cart: "My Cart",
    cart_empty: "Your cart is empty.",
    checkout: "Checkout",
    total: "Total",
    remove: "Remove",
    payment_placeholder: "Payment gateway is under development. Your order was saved as a request.",
    orders: "My Orders",
    order_placed: "Order placed",
    membership: "Membership",
    basic_membership: "Basic Membership",
    pro_membership: "Buyer / Seller",
    searches_left: "Searches Left",
    unlimited: "Unlimited",
    upgrade: "Upgrade ($3000/Year)",
    upgrade_success: "Your membership was upgraded to Buyer/Seller!",
    request_sent: "Your membership request was received. Our team will email you to arrange payment. Your account is activated after payment.",
    request_membership: "Request ($3000/Year)",
    activation_note: "Activated after payment is completed.",
    basic_desc: "10 part searches",
    pro_desc: "Unlimited searches + list your own parts in the system",
    sell_parts: "Sell / List Parts",
    my_parts: "My Parts",
    add_part: "Add Part",
    pn: "Part Number (PN)",
    part_name: "Part Name",
    category: "Category",
    quantity: "Quantity",
    part_added: "Part added",
    admin_panel: "Admin Panel",
    dashboard: "Dashboard",
    stats: "Statistics",
    stock_mgmt: "Stock Management",
    order_mgmt: "Order Management",
    search_logs: "Search Logs",
    visits_tab: "Site Visits",
    visitors: "Visitors",
    unique_visitors: "Unique Visitors",
    country: "Country",
    visits_count: "Visits",
    total_users: "Users",
    total_orders: "Orders",
    pending: "Pending",
    total_stock: "Stock Items",
    total_searches: "Searches",
    status: "Status",
    date: "Date",
    query: "Query",
    save: "Save",
    cancel: "Cancel",
    delete: "Delete",
    contact_us: "Contact: info@milsissav.com",
    limit_reached: "Basic search limit reached. Upgrade for unlimited searches.",
    select_category_first: "Please select a field first (Drone, Aircraft or Machinery).",
    hero_sub: "Instantly find Drone, Aircraft and Machinery spare parts worldwide with AI.",
    memberships_tab: "Memberships",
    valid_until: "Valid until",
    download_invoice: "Download Invoice (PDF)",
    days_short: "days",
    invoice_archive: "Past Invoices",
    member_activate: "Activate",
    member_deactivate: "Deactivate",
    member_activated: "Membership activated and the user was notified by email",
    member_deactivated: "Membership deactivated",
    requested_at: "Requested",
    plan: "Plan",
    no_requests: "No membership requests",
    status_pending: "Awaiting Payment",
    status_approved: "Active",
    admin_login_title: "Admin Login",
    admin_login_desc: "This area is for administrators only",
    admin_login_error: "Only administrators can access this area",
    back_to_site: "← Back to site",
  },
};
